import React from 'react'
import PropTypes from 'prop-types';
import axios from "axios";
import * as Icon from 'react-feather';
import { Link } from "react-router-dom";
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';
import { formatNumberWithCustomSymbol } from '../assets/salaryformat';
const ProfileBiodata = ({ packageId, item, onClick, type, onClickBiodata, selectedBiodata, setSelectedBiodata, onRefresh}) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const handleClick = (item) => {
    onClickBiodata && onClickBiodata(item); // kirim ke parent
    if (onClick) {
      onClick(item);
    }
  };

  const parseDMYToDate = (dmy) => {
    const [day, month, year] = dmy.split("/");

    return new Date(`${year}-${month}-${day}`);
  }

  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();

    const monthDifference = today.getMonth() - birthDate.getMonth();
    const dayDifference = today.getDate() - birthDate.getDate();


    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--;
    }

    return age;
  }

  const handleShortlist = async (type, package_id, biodata_id) => {
    const typeurl = '/employer-biodata-shared/'

    const data = {
      type: type,
      package_id: package_id,
      biodata_id: biodata_id
    }

    try {
      // eslint-disable-next-line no-undef
      const response = await axios.post(process.env.REACT_APP_BASE_URL+typeurl, data);

      if (response.status === 200) {
        console.log('success');
        if (onRefresh) onRefresh();
      } else {
        console.error('failed'); 
      }
    } catch (error) {
      console.error("Shortlist error:", error);
    }
  }

  return (
    <div className="bg-white rounded-bottom w-100 border-2 d-flex flex-column" style={{ height: '100%' }}>
      <div className="d-flex justify-content-end mb-2 py-2 rounded">
        {/* Left - optional checkbox */}
        {type == "agency" ? (
          <div className="me-2">
            <input
              type="checkbox"
              className="form-check-input"
              id={`mobile-checkbox-${item.id}`}
              checked={selectedBiodata.some(
                (b) => b.id === item.id && b.is_agency === !!item.agency
              )}
              onChange={(e) => {
                if (e.target.checked) {
                  setSelectedBiodata((prev) => [
                    ...prev,
                    { id: item.id, is_agency: !!item.agency },
                  ]);
                } else {
                  setSelectedBiodata((prev) =>
                    prev.filter(
                      (b) =>
                        !(
                          b.id === item.id &&
                          b.is_agency === !!item.agency
                        )
                    )
                  );
                }
              }}
            />
          </div>
        ) : (
          <div className="me-2" style={{ width: '16px' }}></div> // placeholder to maintain spacing
        )}

        {/* Center - profile */}
        <div className="flex-grow-1 text-center">
          <Link
            to={{
              pathname: !user ? `/biodata-employer/${item.id}` : `/biodata/${item.id}`,
              state: { profile: item },
            }}
            className="avatar avatar-md mb-2"
            style={{ width: 100, height: 100 }}
          >
            {item.imgprofile ? (
              <img
                className="avatar-img rounded-circle"
                src={item.imgprofile}
                width="200"
                alt="User"
              />
            ) : (
              <i className="fas fa-user text-muted position-absolute top-50 start-50 translate-middle" style={{ fontSize: "27px" }}></i>
            )}
          </Link>
        </div>

        {/* Right - badge */}
        <div className='m-2'>
          {item.status === "Published" ? (
            <span className="badge bg-success-light">
              <Icon.CheckCircle size={17} />{" "}
              {type === "employer" ? "Available" : item.status}
            </span>
          ) : item.status === "Draft" ? (
            <span className="badge bg-info">
              <Icon.AlertCircle size={17} /> {item.status}
            </span>
          ) : item.status === "On-Hold" ? (
            <span className="badge bg-light border text-dark">
              <Icon.PauseCircle size={17} /> {item.status}
            </span>
          ) : item.status === "Booked" ? (
            <span className="badge bg-primary-light border text-dark">
              <Icon.BookOpen size={17} /> {item.status}
            </span>
          ) : item.status === "Removed" ? (
            <span className="badge bg-danger border text-light">
              <Icon.BookOpen size={17} /> {item.status}
            </span>
          ) : (
            <span className="badge bg-dark border text-light">
              <Icon.MinusCircle size={17} /> {item.status}
            </span>
          )}
          <div className='mt-2 d-flex justify-content-end' style={{cursor: 'pointer'}}>
            <span className='d-flex align-items-center badge badge-pill bg-light text-secondary' onClick={() => handleShortlist(item.supplier ? 'supplier' : 'agency', packageId, item.id)}><Icon.Star size={17} className='me-1' style={item.shortlisted ? {color: 'gold'} : {color: 'inherit'}} fill={item.shortlisted ? 'gold' : 'none'}/> {t("Shortlist")}</span>
          </div>
        </div>
      </div>

      {/* Content section - grows to fill available space */}
      <div className="flex-grow-1 px-4 py-3">
        {/* Header Section */}
        <div className='d-flex justify-content-between align-items-start mb-4'>
          <div className='flex-grow-1'>
            <h5 className="fw-bold text-dark mb-1 lh-base">{item.name}</h5>
          </div>
          <div className='ms-3'>
            <span className='badge bg-light text-muted px-3 py-2 rounded-pill fw-medium' style={{fontSize: '0.875rem'}}>{item.code}</span>
          </div>
        </div>

        {/* Profile Section */}
        <div className='mb-4'>
          <h6 className='fw-bold text-dark mb-3 text-uppercase' style={{letterSpacing: '0.5px', fontSize: '0.875rem'}}>
            Profile Information
          </h6>
          <div className='profile-details'>
            <div className='d-flex align-items-center py-2 px-2 border-bottom border-light' style={{transition: 'all 0.2s ease'}} 
                 onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                 onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}>
              <div style={{minWidth: '120px', flexShrink: 0}}>
                <span className='text-muted fw-medium'>{t("Nationality")}</span>
              </div>
              <div style={{flex: 1, marginLeft: '20px'}}>
                <span className='text-dark fw-medium'>{item.nationality}</span>
              </div>
            </div>
            <div className='d-flex align-items-center py-2 px-2 border-bottom border-light' style={{transition: 'all 0.2s ease'}}
                 onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                 onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}>
              <div style={{minWidth: '120px', flexShrink: 0}}>
                <span className='text-muted fw-medium'>{t("Marital")}</span>
              </div>
              <div style={{flex: 1, marginLeft: '20px'}}>
                <span className='text-dark fw-medium'>{t(item.marital)}</span>
              </div>
            </div>
            <div className='d-flex align-items-center py-2 px-2 border-bottom border-light' style={{transition: 'all 0.2s ease'}}
                 onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                 onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}>
              <div style={{minWidth: '120px', flexShrink: 0}}>
                <span className='text-muted fw-medium'>{t("Age")}</span>
              </div>
              <div style={{flex: 1, marginLeft: '20px'}}>
                <span className='text-dark fw-medium'>
                  {item.dob ? (
                    <span>
                      {calculateAge(parseDMYToDate(item.dob))} {t("Years Old")}
                    </span>
                  ) : ""}
                </span>
              </div>
            </div>
            <div className='d-flex align-items-center py-2 px-2 border-bottom border-light' style={{transition: 'all 0.2s ease'}}
                 onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                 onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}>
              <div style={{minWidth: '120px', flexShrink: 0}}>
                <span className='text-muted fw-medium'>{t("Religion")}</span>
              </div>
              <div style={{flex: 1, marginLeft: '20px'}}>
                <span className='text-dark fw-medium'>{t(item.religion)}</span>
              </div>
            </div>
            <div className='d-flex align-items-center py-2 px-2' style={{transition: 'all 0.2s ease'}}
                 onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                 onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}>
              <div style={{minWidth: '120px', flexShrink: 0}}>
                <span className='text-muted fw-medium'>{t("Education")}</span>
              </div>
              <div style={{flex: 1, marginLeft: '20px'}}>
                <span className='text-dark fw-medium'>{item.education}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Areas of Work Section */}
        <div className='mb-4'>
          <h6 className='fw-bold text-dark mb-3 text-uppercase' style={{letterSpacing: '0.5px', fontSize: '0.875rem'}}>
            Areas of Expertise
          </h6>
          <div className='d-flex flex-wrap gap-2'>
            {item.areas_of_work.infants.willing && (
              <span className='badge px-3 py-2 rounded-pill fw-medium border' 
                    style={{
                      backgroundColor: 'rgba(13, 110, 253, 0.1)', 
                      color: '#0d6efd', 
                      borderColor: 'rgba(13, 110, 253, 0.25)',
                      fontSize: '0.875rem',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'translateY(-1px)';
                      e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = 'none';
                    }}>
                {t("Infants")}
              </span>
            )}
            {item.areas_of_work.elderly.willing && (
              <span className='badge px-3 py-2 rounded-pill fw-medium border' 
                    style={{
                      backgroundColor: 'rgba(25, 135, 84, 0.1)', 
                      color: '#198754', 
                      borderColor: 'rgba(25, 135, 84, 0.25)',
                      fontSize: '0.875rem',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'translateY(-1px)';
                      e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = 'none';
                    }}>
                {t("Elderly")}
              </span>
            )}
            {item.areas_of_work.disabled.willing && (
              <span className='badge px-3 py-2 rounded-pill fw-medium border' 
                    style={{
                      backgroundColor: 'rgba(13, 202, 240, 0.1)', 
                      color: '#0dcaf0', 
                      borderColor: 'rgba(13, 202, 240, 0.25)',
                      fontSize: '0.875rem',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'translateY(-1px)';
                      e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = 'none';
                    }}>
                {t("Disabled")}
              </span>
            )}
            {item.areas_of_work.housework.willing && (
              <span className='badge px-3 py-2 rounded-pill fw-medium border' 
                    style={{
                      backgroundColor: 'rgba(255, 193, 7, 0.1)', 
                      color: '#ffc107', 
                      borderColor: 'rgba(255, 193, 7, 0.25)',
                      fontSize: '0.875rem',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'translateY(-1px)';
                      e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = 'none';
                    }}>
                {t("Housework")}
              </span>
            )}
            {item.areas_of_work.cooking.willing && (
              <span className='badge px-3 py-2 rounded-pill fw-medium border' 
                    style={{
                      backgroundColor: 'rgba(220, 53, 69, 0.1)', 
                      color: '#dc3545', 
                      borderColor: 'rgba(220, 53, 69, 0.25)',
                      fontSize: '0.875rem',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'translateY(-1px)';
                      e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = 'none';
                    }}>
                {t("Cooking")}
              </span>
            )}
          </div>
        </div>

        {/* Salary Section */}
        <div className='mb-3'>
          <div className='d-flex align-items-center p-3 bg-light rounded-3 border'>
            <div className='w-100'>
              <div className='text-muted small fw-medium mb-1 text-uppercase' style={{letterSpacing: '0.5px', fontSize: '0.75rem'}}>Salary</div>
              <div className='h6 mb-0 text-dark fw-bold'>
                {formatNumberWithCustomSymbol(item.salaries.SGD)}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Action buttons section - stays at bottom */}

      <div className="d-flex justify-content-end mt-auto">
        {
          type == "employer" && (
            <button className='btn btn-primary me-2' data-bs-toggle="modal" data-bs-target="#book_biodata_dialog" disabled={item.status != 'Published'} onClick={onClick}>{t("Book")}</button>
          )
        }
        
        {type == "supplier" && (
          <>
            <button className="btn btn-greys me-2" data-bs-toggle="modal" data-bs-target="#broadcast_modal" onClick={() => handleClick(item)} disabled={item.status != "Published"}>
              <Icon.Send /> {t("Broadcast")}
            </button>
          </>)
        }

        {
          (type == "agency" && item.status == "Published" && user && user.company && user.company.is_premium) && (
            <>
                <button
                    type="button"
                    className="btn btn-greys m-2"
                    data-bs-toggle="modal"
                    data-bs-target="#book_biodata_dialog"
                    onClick={() => handleClick(item)}
                    disabled={!item.booking_status && item.is_have_booking}
                    >
                      
                    {!item.booking_status && item.is_have_booking ? 
                  (
                    <>
                      <Icon.PauseCircle /> {t("On Hold")}
                    </>
                  ) : (
                    <>
                      <Icon.Mic /> {t("Book")}
                    </>
                  )
                  }
                </button>
              </>
          )
        }

        {
          (() => {
            let isBiodataOwner = false;
            if (type === "supplier") {
              isBiodataOwner = item.supplier ? true : false;
            } else if (type === "agency") {
              isBiodataOwner = item.agency ? true : false;
            }
            
            return isBiodataOwner && item.status === "Draft" && (
              <button 
                type="button"
                className="btn btn-greys m-2"
                data-bs-toggle="modal"
                data-bs-target="#modal_publish"
                onClick={() => handleClick(item)}
                >
                {t("Publish")}
              </button>
            );
          })()
        }
      </div>
    </div>
  )
}

ProfileBiodata.propTypes = {
  packageId: PropTypes.string.isRequired,
  item: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.string.isRequired,
  onClickBiodata: PropTypes.func,
  selectedBiodata: PropTypes.array,
  setSelectedBiodata: PropTypes.func,
  onRefresh: PropTypes.func,
};

export default ProfileBiodata